// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__37Nzf","footer":"ModalUpdate_footer__2s9Ct"};